import { Box } from "@mui/material";
import TextInputWithChips from "../../Generals/Inputs/TextInputWithChip.js";

const FilterGroupsChips = ({
  selectedGroups,
  onChangeGroups,
  groups,
}) => {

  const groupOptions = ["All", ...(groups || [])];

  const handleSelectedGroups = (chips) => {
    if (chips.includes("All")) {
      onChangeGroups(["All"]);
    } else if (chips.length === 0) {
      onChangeGroups([]);
    } else {
      onChangeGroups(chips);
    }
  };

  return (
    <Box sx={{ minWidth: "220px", width: "auto", marginTop: "-20px" }}>
      <TextInputWithChips
        title="Groups"
        options={groupOptions}
        selectedOptions={selectedGroups}
        onSelectedOptions={handleSelectedGroups}
      />
    </Box>
  );
};

export default FilterGroupsChips;